import styled from 'styled-components';

export const StyledPage = styled.div`
  @media (min-width: 481px) {
    width: 100%;
    margin: 0 auto;
    max-height: calc(100vh - 72px);
  }
`;
